import TableFilter from '../table-models/TableFilter';

export const defaultOrganizationsFilters = (): TableFilter[] => [
    { field: 'name', label: 'Name', value: '' },
    { field: 'email', label: 'Email', value: '' },
];
